document.addEventListener('DOMContentLoaded',()=>{
    if (window.innerWidth <= 960) {
        createFlickity(
            '.container__extra-information-items',
            '.container__extra-information-items .flickity-button.flickity-prev-next-button.next, .container__extra-information-items .flickity-button.flickity-prev-next-button.previous',
            5,
            1,
            false,
            false
        )

        if (location.pathname.includes('/products')) {
            let observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        let elem = entry.target;
                        setTimeout(() => {
                            createFlickity(
                                'product-recommendations .product-grid',
                                '.product-recommendations .product-grid .flickity-button.flickity-prev-next-button.next,product-recommendations .product-grid .flickity-button.flickity-prev-next-button.previous',
                                5,
                                1,
                                false,
                                true
                            )
                            calcWidthDot('product-recommendations .flickity-page-dots .dot',1)

                        }, 1000);
                    }
                });
            });
            var target = document.querySelector('product-recommendations');
            observer.observe(target);
        }
    }
    // Collection list
    createFlickity(
        '.collection-list__items',
        '.collection-list__items .flickity-prev-next-button.next, .collection-list__items .flickity-prev-next-button.previous',
        6,
        1,
        false,
        false
    )

    createFlickity(
        '.featured-collection',
        '.featured-collection .flickity-prev-next-button.next, .featured-collection .flickity-prev-next-button.previous',
        5,
        1,
        false,
        true
    )
    if (window.innerWidth <= 768)  calcWidthDot('.featured-collection .flickity-page-dots .dot', 3)

    createFlickity('.featured-collection-banner','.featured-collection-banner .flickity-prev-next-button.next, .featured-collection-banner .flickity-prev-next-button.previous',1,1,false,true)
    if (window.innerWidth <= 768)  calcWidthDot('.featured-collection-banner .flickity-page-dots .dot', 3)

})
function createFlickity(
    flickityClass, arrow, gcDesktop, gcMobile, gcTablet = 3,
    dotsDesktop, dotsMobile, fsDesktop = false, fsMobile = false
) {
    const allFlickityContainer = document.querySelectorAll(flickityClass)
    if (!!!allFlickityContainer) return

    let groupCells = gcDesktop
    let dotValue = dotsDesktop
    let freeScroll = fsDesktop
    if (window.innerWidth <= 900) groupCells = gcTablet

    if (window.innerWidth <= 768) {
        groupCells = gcMobile
        dotValue = dotsMobile
        freeScroll = fsMobile
    }
    allFlickityContainer.forEach(flickityContainer => {
        var flkty = new Flickity( flickityContainer, {
            // options
            cellAlign: 'left',
            contain: true,
            groupCells: groupCells,
            pageDots: dotValue,
            freeScroll: freeScroll
        });

        if ( typeof window.INNOVATE_CAROUSELS === 'undefined' ) window.INNOVATE_CAROUSELS = {}
        const existClass = window.INNOVATE_CAROUSELS[flickityClass]
        window.INNOVATE_CAROUSELS[flickityClass] = typeof existClass === 'undefined'
            ? [flkty]
            : [...existClass, flkty]
    });

    const allArrow = document.querySelectorAll(arrow)
    allArrow.forEach(arrow => {
        arrow.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
            <g id="arrow" transform="translate(165.193 2804) rotate(180)">
                <rect id="Rectángulo_184" data-name="Rectángulo 184" width="44" height="44" rx="22" transform="translate(165.193 2804) rotate(180)" fill="#7fc2e2"/>
                <path id="arrow-right" d="M14.307,0l-.941.941L17.36,4.936H0V6.267H17.36l-3.994,3.994.941.941,5.6-5.6Z" transform="translate(153.085 2787.232) rotate(180)" fill="#fff"/>
            </g>
        </svg>
        `
    });
}
function calcWidthDot(classDots) {
    const allDots = document.querySelectorAll(classDots)
    allDots.forEach( dot =>{
        dot.style.width = `${100 / Number(dot.parentElement.childElementCount)}%`
    })

}
